import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React__default, { useContext, useState, useEffect } from 'react';
import { GroupChannelHandler } from '@sendbird/chat/groupChannel';
import { a as LocalizationContext } from '../../LocalizationContext-a82461b5.js';
import { u as uuidv4 } from '../../uuid-717930b4.js';
import { L as Label, a as LabelTypography, b as LabelColors } from '../../index-6420013c.js';
import { u as useChannelContext } from '../../ChannelProvider-5dcbee7b.js';
import useSendbirdStateContext from '../../useSendbirdStateContext.js';
import '../../stringSet-b60e9529.js';
import '../../index-6add7940.js';
import 'prop-types';
import '../../UserProfileContext-f3f446d2.js';
import '../../const-72f012b6.js';
import '../../index-ccef08fe.js';
import '../../topics-eb548880.js';
import '../../index-579ca9d7.js';
import '../../_rollupPluginBabelHelpers-05128ded.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../compareIds-2e50e905.js';
import '@sendbird/chat/message';
import '../../consts-fa6ab3c0.js';
import '../../resolvedReplyType-9d00a3db.js';
import '../../withSendbird.js';
var TypingIndicatorText = function TypingIndicatorText(_ref) {
  var members = _ref.members;
  var _useContext = useContext(LocalizationContext),
    stringSet = _useContext.stringSet;
  if (!members || members.length === 0) {
    return '';
  }
  if (members && members.length === 1) {
    return "".concat(members[0].nickname, " ").concat(stringSet.TYPING_INDICATOR__IS_TYPING);
  }
  if (members && members.length === 2) {
    return "".concat(members[0].nickname, " ").concat(stringSet.TYPING_INDICATOR__AND, " ").concat(members[1].nickname, " ").concat(stringSet.TYPING_INDICATOR__ARE_TYPING);
  }
  return stringSet.TYPING_INDICATOR__MULTIPLE_TYPING;
};
var TypingIndicator = function TypingIndicator() {
  var _globalStore$stores, _globalStore$stores$s, _globalStore$config;
  var _useChannelContext = useChannelContext(),
    channelUrl = _useChannelContext.channelUrl;
  var globalStore = useSendbirdStateContext();
  var sb = globalStore === null || globalStore === void 0 ? void 0 : (_globalStore$stores = globalStore.stores) === null || _globalStore$stores === void 0 ? void 0 : (_globalStore$stores$s = _globalStore$stores.sdkStore) === null || _globalStore$stores$s === void 0 ? void 0 : _globalStore$stores$s.sdk;
  var logger = globalStore === null || globalStore === void 0 ? void 0 : (_globalStore$config = globalStore.config) === null || _globalStore$config === void 0 ? void 0 : _globalStore$config.logger;
  var _useState = useState(uuidv4()),
    _useState2 = _slicedToArray(_useState, 2),
    handlerId = _useState2[0],
    setHandlerId = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    typingMembers = _useState4[0],
    setTypingMembers = _useState4[1];
  useEffect(function () {
    var _sb$groupChannel;
    if (sb !== null && sb !== void 0 && (_sb$groupChannel = sb.groupChannel) !== null && _sb$groupChannel !== void 0 && _sb$groupChannel.addGroupChannelHandler) {
      sb.groupChannel.removeGroupChannelHandler(handlerId);
      var newHandlerId = uuidv4();
      var handler = new GroupChannelHandler({
        onTypingStatusUpdated: function onTypingStatusUpdated(groupChannel) {
          // there is a possible warning in here - setState called after unmount
          logger.info('Channel > Typing Indicator: onTypingStatusUpdated', groupChannel);
          if (groupChannel.url === channelUrl) {
            var members = groupChannel.getTypingUsers();
            setTypingMembers(members);
          }
        }
      });
      sb.groupChannel.addGroupChannelHandler(newHandlerId, handler);
      setHandlerId(newHandlerId);
    }
    return function () {
      var _sb$groupChannel2;
      setTypingMembers([]);
      if (sb !== null && sb !== void 0 && (_sb$groupChannel2 = sb.groupChannel) !== null && _sb$groupChannel2 !== void 0 && _sb$groupChannel2.removeGroupChannelHandler) {
        sb.groupChannel.removeGroupChannelHandler(handlerId);
      }
    };
  }, [channelUrl]);
  return /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-conversation__footer__typing-indicator__text",
    type: LabelTypography.CAPTION_2,
    color: LabelColors.ONBACKGROUND_2
  }, /*#__PURE__*/React__default.createElement(TypingIndicatorText, {
    members: typingMembers
  }));
};
export { TypingIndicatorText, TypingIndicator as default };